export const shiftArray = (arr: number[], direction: 1 | -1, n: number) => {
  const times = n > arr.length ? n % arr.length : n;

  return arr.concat(arr.splice(0, direction > 0 ? arr.length - times : times));
};
